import SpaceAvatarContainer, { SpaceAvatar } from "./SpaceAvatar";

export default SpaceAvatarContainer;
export { SpaceAvatar };
